export default "__VITE_ASSET__B32U96Cd__"